module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0001.jpg?v=6c90f987";